define('models/customer_product',['require','backbone','models/product'],function(require){

    var Backbone = require('backbone');

    var ProductModel = require('models/product');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'customer-licenses/' + this.id + '/' ) :
                ( App.Config.apiBase + 'customer-licenses/' );
        },

        defaults: function () {
            return {
                id: null,
                customer: null,
                license_email: '',
                product: new ProductModel().attributes,
                start_time: '',
                end_time: '',
                extra_data: [],
                is_activated: false,
                is_valid: false
            };
        }
    });
});
